<script>
import { Line } from 'vue-chartjs';
// TP1/TODO: je to staticke az se to bude predelavat s BE tak to udelam v TS

export default {
	name: 'LineChart',
	extends: Line,
	data() {
		return {
			datacollection: {
				labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
				datasets: [
					{
						label: 'Škoda',
						borderColor: '#2da62d',
						fill: false,
						backgroundColor: 'none',
						pointBackgroundColor: 'white',
						borderWidth: 2,
						pointBorderColor: '#249EBF',
						data: [20, 11, 13, 15, 22, 13, 11, 22, 18, 16, 15, 28],
					},
					{
						label: 'Audi',
						borderColor: '#f83b33',
						backgroundColor: 'none',
						fill: false,
						pointBackgroundColor: 'white',
						borderWidth: 2,
						pointBorderColor: '#249EBF',
						data: [11, 15, 15, 12, 8, 13, 15, 24, 18, 16, 9, 20],
					},
					{
						label: 'Seat',
						borderColor: '#005BF8',
						backgroundColor: 'none',
						fill: false,
						pointBackgroundColor: 'white',
						borderWidth: 2,
						pointBorderColor: '#249EBF',
						data: [12, 6, 8, 8, 14, 13, 11, 18, 9, 16, 15, 14],
					},
				],
			},
			options: {
				scales: {
					yAxes: [{
						scaleLabel: {
							display: true,
							labelString: 'počet prodaných aut',
						},
						ticks: {
							beginAtZero: true,
						},
						gridLines: {
							display: true,
						},
					}],
					xAxes: [{
						gridLines: {
							display: false,
						},
					}],
				},
				legend: {
					display: true,
				},
				responsive: true,
				maintainAspectRatio: false,
			},
		};
	},
	mounted() {
		// renderChart function renders the chart with the datacollection and options object.
		this.renderChart(this.datacollection, this.options);
	},
};
</script>

<style scoped>

</style>
